import { HpControlActionTypes } from '@avantia/questionset-model';
import { registerActionPromise } from './actions/dependentActionRunner';
import { registerButtonClickAction } from './reducers/questionSetReducer';
import {
  HpClientButtonClickActionFunction,
  HpCreateActionPromisesProps,
  HpDependentActionFunction,
  HpRegisterSomethingFunction
} from './types';

export type HpCreateActionPromise<ResponseModelT> = (
  properties: HpCreateActionPromisesProps
) => HpDependentActionFunction<ResponseModelT> | undefined;

export interface HpFeatureSetupProps<ResponseModelT> {
  key: HpControlActionTypes;
  createActionPromise: HpCreateActionPromise<ResponseModelT>;
  buttonClickAction: HpClientButtonClickActionFunction | undefined;
  registerFeature: HpRegisterSomethingFunction | undefined;
}

export function configureFeatures(features: HpFeatureSetupProps<unknown>[]): void {
  features.forEach(({ key, createActionPromise, buttonClickAction, registerFeature }) => {
    registerActionPromise(key, createActionPromise);
    if (buttonClickAction) {
      registerButtonClickAction(key, buttonClickAction, registerFeature);
    }
  });
}
